<script setup lang="ts">
    defineProps<{
        employeeName?: string;
    }>();
</script>

<template>
    <div class="flex items-center gap-1.5">
        <span
            class="size-3 rounded-full"
            :class="employeeName ? 'bg-accent' : 'bg-destructive'"
        ></span>
        <span>
            {{ employeeName || $t('payrolls.existing.not_approved') }}
        </span>
    </div>
</template>
